import React from 'react';

const About = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-8">
          {/* Main Header */}
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold text-primary mb-3">About Us</h1>
            <div className="border-bottom border-primary border-2 mx-auto" style={{width: '80px'}}></div>
          </div>

          {/* Welcome Section */}
          <div className="card shadow-sm border-0 mb-5">
            <div className="card-body p-4 p-md-5">
              <p className="lead text-dark fs-5 lh-base mb-0 text-center">
                Welcome to our professional tailoring service, where precision meets style. 
                We are committed to providing you with the perfect fit and exceptional craftsmanship.
              </p>
            </div>
          </div>

          <div className="row g-5">
            {/* Our Mission Section */}
            <div className="col-md-6">
              <div className="h-100">
                <div className="d-flex align-items-center mb-4">
                  <i className="fas fa-bullseye text-primary fs-3 me-3"></i>
                  <h3 className="h3 fw-bold text-dark mb-0">Our Mission</h3>
                </div>
                <p className="text-muted fs-6 lh-base mb-0">
                  To deliver high-quality tailoring services that exceed customer expectations 
                  through attention to detail, skilled craftsmanship, and personalized service.
                </p>
              </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="col-md-6">
              <div className="h-100">
                <div className="d-flex align-items-center mb-4">
                  <i className="fas fa-star text-primary fs-3 me-3"></i>
                  <h3 className="h3 fw-bold text-dark mb-0">Why Choose Us?</h3>
                </div>
                <ul className="list-unstyled text-muted fs-6">
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Expert tailors with years of experience
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Precise body measurements for perfect fit
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Quality materials and fabrics
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    On-time delivery guaranteed
                  </li>
                  <li className="mb-0">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Customer satisfaction focused
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Information Section */}
         
      <div id="contact-section" className="card shadow-sm border-0 mt-5"></div>
          <div className="card shadow-sm border-0 mt-5">
            <div className="card-body p-4 p-md-5">
              <div className="text-center mb-4">
                <i className="fas fa-map-marker-alt text-primary fs-1 mb-3"></i>
                <h3 className="h3 fw-bold text-dark mb-3">Visit Our Shop</h3>
              </div>
              
              <div className="row text-center g-4">
                <div className="col-md-4">
                  <div className="d-flex flex-column align-items-center">
                    <i className="fas fa-store text-secondary fs-4 mb-2"></i>
                    <h5 className="fw-semibold text-dark mb-2">Address</h5>
                    <p className="text-muted mb-0 small">
                      Fathima Fashion<br />
                      Tirunelveli
                    </p>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="d-flex flex-column align-items-center">
                    <i className="fas fa-phone text-secondary fs-4 mb-2"></i>
                    <h5 className="fw-semibold text-dark mb-2">Phone</h5>
                    <p className="text-muted mb-0 small">
                      +91 9840322598
                    </p>
                  </div>
                </div>
                
                <div className="col-md-4">
                  <div className="d-flex flex-column align-items-center">
                    <i className="fas fa-clock text-secondary fs-4 mb-2"></i>
                    <h5 className="fw-semibold text-dark mb-2">Business Hours</h5>
                    <p className="text-muted mb-0 small">
                      Mon-Sat: 9AM-8PM<br />
                      Sun: 10AM-6PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info Section */}
          <div className="text-center mt-5">
            <div className="bg-light rounded-3 p-4 p-md-5">
              <i className="fas fa-hands-helping text-primary fs-1 mb-3"></i>
              <h4 className="h4 fw-bold text-dark mb-3">Our Commitment</h4>
              <p className="text-muted fs-6 lh-base mb-0 mx-auto" style={{maxWidth: '600px'}}>
                We take pride in transforming fabric into fashion that fits you perfectly. 
                Every stitch tells a story of quality, dedication, and attention to detail that 
                has been our tradition for years.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .card:hover {
          transform: translateY(-2px);
        }
        li {
          transition: color 0.2s ease;
        }
        li:hover {
          color: #495057 !important;
        }
      `}</style>
    </div>
  );
};

export default About;